import DatePicker from "react-datepicker";
import { Controller, useFormContext } from "react-hook-form";

import type { FieldValues } from "react-hook-form";
import type { FormFieldProps } from "semantic-ui-react";

type ShallowPath<T> = keyof T & string;
type FormDatePickerRawProps<T extends FieldValues> = {
  name: ShallowPath<T>;
  minDate?: Date;
  disabled?: boolean;
  dateFormat?: string;
  placeholder?: string;
  todayButton?: string;
  showTimeInput?: boolean;
  showTimeSelect?: boolean;
  showYearDropdown?: boolean;
  showMonthDropdown?: boolean;
  showTimeSelectOnly?: boolean;
  minTime?: Date;
  maxTime?: Date;
  timeFormat?: string;
  formFieldProps?: FormFieldProps;
  onChange?: (value: Date | null) => void;
};

export function FormDatePickerRaw<T extends FieldValues>({
  formFieldProps,
  name,
  disabled,
  placeholder,
  dateFormat,
  minDate,
  todayButton,
  showMonthDropdown,
  showYearDropdown,
  showTimeSelect,
  showTimeSelectOnly,
  showTimeInput,
  maxTime,
  minTime,
  timeFormat,
  onChange
}: FormDatePickerRawProps<T>) {
  const { control } = useFormContext<T>();

  return (
    <Controller
      control={control}
      name={name as any}
      {...formFieldProps}
      render={({ field }) => (
        <DatePicker
          showTimeInput={showTimeInput}
          showTimeSelect={showTimeSelect}
          showTimeSelectOnly={showTimeSelectOnly}
          showMonthDropdown={showMonthDropdown}
          showYearDropdown={showYearDropdown}
          selected={field.value}
          onChange={date => {
            field.onChange(date);
            onChange?.(date);
          }}
          onBlur={field.onBlur}
          disabled={disabled}
          placeholderText={placeholder}
          dateFormat={dateFormat || "dd-MM-yyyy"}
          minDate={minDate}
          todayButton={todayButton}
          minTime={minTime}
          maxTime={maxTime}
          timeFormat={timeFormat}
        />
      )}
    />
  );
}
